import React, { memo } from "react";
import Slider from "react-slick";

const TestimonialOne = ({ sellerData }) => {

    const SampleNextArrow = memo((props) => {
        const { className, onClick } = props;
        return (
            <button
                type="button"
                onClick={onClick}
                className={` ${className} slick-next slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-600 text-xl hover-bg-main-600 hover-text-white transition-1`}
            >
                <i className="ph ph-caret-right" />
            </button>
        );
    });
  
    const SamplePrevArrow = memo((props) => {
        const { className, onClick } = props;
        return (
            <button
                type="button"
                onClick={onClick}
                className={`${className} slick-prev slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-600 text-xl hover-bg-main-600 hover-text-white transition-1`}
            >
                <i className="ph ph-caret-left" />
            </button>
        );
    });

    const settings = {
        dots: false,
        arrows: true,
        infinite: true,
        speed: 1000,
        slidesToShow: 4,
        slidesToScroll: 1,
        initialSlide: 0,
        autoplay: true,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        responsive: [
            {
                breakpoint: 1599,
                settings: {
                    slidesToShow: 4,

                },
            },
            {
                breakpoint: 1399,
                settings: {
                    slidesToShow: 3,

                },
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,

                },
            },
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 2,

                },
            },
            {
                breakpoint: 424,
                settings: {
                    slidesToShow: 1,

                },
            },
        ],
    };

    const testimonialsData = sellerData?.customer_reviews;

    return (
        <section className="new-arrival pb-80">
            <div className="container container-lg">                
                <div className="new-arrival__slider arrow-style-two">
                    <Slider {...settings}>
                        {testimonialsData && testimonialsData.length > 0 && testimonialsData.map((testimonial, index) => (
                            <div>
                                <div className="product-cards bg-light-grey  px-8 py-16 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2">
                                    <div className="testimonials-item">
                                        <h6 className="text-uppercase mb-8 fw-medium">
                                            {testimonial?.attributes?.name}
                                        </h6>
                                        <span className="text-md text-black fw-normal">
                                            {testimonial?.attributes?.designation}
                                        </span>
                                        <div className="flex-align gap-8 mt-24">
                                            {[...Array(Number(testimonial?.attributes?.rating) || 0)].map((_, i) => (
                                            <span key={i} className="text-15 fw-medium text-warning-600 d-flex">
                                                <i className="ph-fill ph-star"></i>
                                            </span>
                                            ))}
                                        </div>
                                        <p className="text-xl fw-normal mt-40 max-w-990">
                                            {testimonial?.attributes?.review}
                                        </p>
                                    </div>
                                </div>    
                            </div>
                        ))}                    
                       
                    </Slider>
                </div>
            </div>
        </section>
  );
};

export default TestimonialOne;
